module.exports = __webpack_public_path__ + "static/img/doctor.0897469e.jpg";